export const controllers = [
    // WIRELESS
    {
        name: 'RFGB-20/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 2,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-20',
        previewImage: 'glass-20',
        renderImage: 'glass',
        actuator: false,
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 73.05,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFGB-40/share_dokumentace/AKTUAL/EN/Datasheet_RFGB-20-W,%20RFGB-20-B,%20RFGB-40-W,%20RFGB-40-B.pdf'
    },
    {
        name: 'RFGB-40/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40',
        renderImage: 'glass',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 80.15,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFGB-40/share_dokumentace/AKTUAL/EN/Datasheet_RFGB-20-W,%20RFGB-20-B,%20RFGB-40-W,%20RFGB-40-B.pdf'
    },
    {
        name: 'RFGB-220/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 2,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-20',
        previewImage: 'glass-20-round',
        renderImage: 'glass-round',
        actuator: false,
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 78.08,
    },
    {
        name: 'RFGB-240/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40-round',
        renderImage: 'glass-round',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 85.18,
    },

    {
        name: 'RFSW-22/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 2,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-20',
        previewImage: 'glass-20',
        renderImage: 'glass',
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-22/S',
            name: '',
            refImg: 'default_controller.png',
            dinrail: false,
            numberOfChannels: 2,
            usage: 'switching',
            applianceType: 'lighting',
        },
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 127.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFSW-22S/EN/Datasheet_RFSW-xx-S.pdf'
    },
    {
        name: 'RFSW-222/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 2,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-20',
        previewImage: 'glass-20-round',
        renderImage: 'glass-round',
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-222/S',
            name: '',
            refImg: 'default_controller.png',
            dinrail: false,
            numberOfChannels: 2,
            usage: 'switching',
            applianceType: 'lighting',
        },
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 127.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFSW-222S/EN/Datasheet_RFSW-xx-S.pdf'
    },
    {
        name: 'RFSW-42/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40',
        renderImage: 'glass',
        configurableHotelFeatures: true,
        hotelFeatures: ['doNotDisturb', 'makeUpRoom'],
        removeableHotelFeatures: true,
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-42/S',
            name: '',
            refImg: 'controller_black.png',
            dinrail: false,
            numberOfChannels: 2,
            applianceType: 'lighting',
            usage: 'switching'
        },
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 127.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFSW-22S/EN/Datasheet_RFSW-xx-S.pdf'
    },
    {
        name: 'RFSW-242/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40-round',
        renderImage: 'glass-round',
        configurableHotelFeatures: true,
        hotelFeatures: ['doNotDisturb', 'makeUpRoom'],
        removeableHotelFeatures: true,
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-242/S',
            name: '',
            refImg: 'controller_black_round.png',
            dinrail: false,
            numberOfChannels: 2,
            applianceType: 'lighting',
            usage: 'switching'
        },
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 127.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFSW-222S/EN/Datasheet_RFSW-xx-S.pdf'
    },
    {
        name: 'RFSW-62/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 6,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-60',
        previewImage: 'glass-60',
        renderImage: 'glass',
        configurableHotelFeatures: true,
        hotelFeatures: ['doNotDisturb', 'makeUpRoom'],
        removeableHotelFeatures: true,
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-62/S',
            name: '',
            refImg: 'controller_black.png',
            dinrail: false,
            numberOfChannels: 2,
            applianceType: 'lighting',
            usage: 'switching'
        },
        buttonCodes: {
            0: 'A',
            1: 'D',
            2: 'G',
            3: 'C',
            4: 'F',
            5: 'I'
        },
        price: 137.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFSW-22S/EN/Datasheet_RFSW-xx-S.pdf'
    },
    {
        name: 'RFSW-262/S',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 6,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-60',
        previewImage: 'glass-60-round',
        renderImage: 'glass-round',
        configurableHotelFeatures: true,
        hotelFeatures: ['doNotDisturb', 'makeUpRoom'],
        removeableHotelFeatures: true,
        actuator: true,
        actuatorDetails: {
            type: 'RFSW-262/S',
            name: '',
            refImg: 'controller_black.png',
            dinrail: false,
            numberOfChannels: 2,
            applianceType: 'lighting',
            usage: 'switching'
        },
        buttonCodes: {
            0: 'A',
            1: 'D',
            2: 'G',
            3: 'C',
            4: 'F',
            5: 'I'
        },
        price: 137.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFSW-22S/EN/Datasheet_RFSW-xx-S.pdf'
    },

    {
        name: 'RFDW-71/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40',
        renderImage: 'glass',
        actuator: true,
        actuatorDetails: {
            type: 'RFDW-71',
            name: '',
            refImg: 'controller_black.png',
            dinrail: false,
            numberOfChannels: 4,
            applianceType: 'lighting',
            usage: 'dimming'
        },
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 143.52,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFDW-71/share_dokumentace/RFDW-71B/EN/Datasheet_RFDW-71-W,%20RFDW-71-B.pdf'
    },
    {
        name: 'RFDW-271/',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 4,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40-round',
        renderImage: 'glass-round',
        actuator: true,
        actuatorDetails: {
            type: 'RFDW-271',
            name: '',
            refImg: 'controller_black_round.png',
            dinrail: false,
            numberOfChannels: 4,
            applianceType: 'lighting',
            usage: 'dimming'
        },
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 157.92,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFDW-271/share_dokumentace/RFDW-271B/EN/Datasheet_RFDW-71-W,%20RFDW-71-B.pdf'
    },

    {
        name: 'RFTC-3/',
        type: 'thermostat',
        thermostatAppliance: 'fancoil',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 6,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-6',
        previewImage: 'rftc-3-6',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
        price: 190,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFTC-3/EN/Datasheet_RFTC-3.pdf'
    },
    {
        name: 'RFTC-3/',
        type: 'thermostat',
        thermostatAppliance: 'fancoil',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-3-8',
        renderImage: 'rftc',
        configurableHotelFeatures: true,
        hotelFeatures: ['doNotDisturb', 'makeUpRoom'],
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/red/10C",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/green/10A",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
        price: 190,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFTC-3/EN/Datasheet_RFTC-3.pdf'
    },

    /*{
        name: 'RFTC-4/',
        type: 'thermostat',
        thermostatAppliance: 'fancoil',
        thermostatRequiredActuator: {
            tech: 'wireless',
            type: 'RFSA-66M',
            applianceType: 'hvac',
            usage: 'switching',
            name: GetNameWithTranslation('6x 8A', 'channels'),
            refImg: 'RFSA-66M.png',
            icon: 'actuator_din_3',
            dinrail: true,
            numberOfChannels: 6,
            price: 125.49
        },
        tech: "wireless",
        material: 'glass',
        icons: 6,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-6',
        previewImage: 'rftc-3-6',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
        price: 190
    },
    {
        name: 'RFTC-4/',
        type: 'thermostat',
        thermostatAppliance: 'fancoil',
        thermostatRequiredActuator: {
            tech: 'wireless',
            type: 'RFSA-66M',
            applianceType: 'hvac',
            usage: 'switching',
            name: GetNameWithTranslation('6x 8A', 'channels'),
            refImg: 'RFSA-66M.png',
            icon: 'actuator_din_3',
            dinrail: true,
            numberOfChannels: 6,
            price: 125.49
        },
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-3-8',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/red/10C",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/green/10A",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
        price: 190
    },*/
    {
        name: 'RFTC-6/',
        type: 'thermostat',
        thermostatAppliance: 'electric',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-6',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/1G",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/1H",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/%c/2I",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/%c/2J",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/1I",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11F",
                "applianceId": null,
            }
        ],
        price: 164.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFTC-6/EN/Datasheet_RFTC-6.pdf'
    },
    {
        name: 'RFTC-7/',
        type: 'thermostat',
        thermostatAppliance: 'radiator',
        thermostatRequiredActuator: ['RFATV-2', 'TELVA-3'],
        thermostatRequiredActuatorMaxCount: 16,
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-7',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/1G",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/1H",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/%c/2I",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/%c/2J",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/1I",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11F",
                "applianceId": null,
            }
        ],
        price: 149.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFTC-7/EN/Datasheet_RFTC-7.pdf'
    },
    {
        name: 'RFTC-9/',
        type: 'thermostat',
        thermostatAppliance: 'vrv',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'rftc-3-8',
        renderImage: 'rftc',
        configurableHotelFeatures: true,
        hotelFeatures: ['doNotDisturb', 'makeUpRoom'],
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/red/10C",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/green/10A",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
    },
    {
        name: 'RFTC-9/',
        type: 'thermostat',
        thermostatAppliance: 'vrv',
        thermostatRequiredActuator: null,
        tech: "wireless",
        material: 'glass',
        icons: 6,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-6',
        previewImage: 'rftc-3-6',
        renderImage: 'rftc',
        unremoveableIcons: true,
        actuator: false,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ],
    },

    // Infront of door units

    {
        name: 'RFGS-30/S',
        selectorCategory: 'infront_of_door_unit',
        type: 'controller',
        tech: 'wireless',
        material: 'glass',
        icons: 3,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-infront-unit-3',
        previewImage: 'rfgs-30',
        renderImage: 'glass',
        configurableHotelFeatures: true,
        hotelFeatures: ['doNotDisturb', 'makeUpRoom', 'doorbell'],
        actuator: true,
        actuatorDetails: {
            type: 'RFGS-30/S',
            name: '',
            refImg: 'controller_black.png',
            dinrail: false,
            numberOfChannels: 2,
            applianceType: 'lighting',
            usage: 'switching'
        },
        buttonCodes: {
            0: 'C',
            1: 'F',
            2: 'I'
        },
        unremoveableIcons: true,
        defaultIconsData: [
           {
                "position": 0,
                "color": "red",
                "icon": "controllers/red/10C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/15A",
                "applianceId": null
            },
            {
                "position": 2,
                "color": "green",
                "icon": "controllers/green/10A",
                "applianceId": null,
            },
        ],
        hasRoomNumber: true
    },

    // Metal

    {
        name: 'RFMB-22/',
        type: 'controller',
        tech: 'wireless',
        material: 'metal',
        icons: 2,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-20',
        previewImage: 'metal-20',
        renderImage: 'metal-2',
        actuator: false,
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 142.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFMB-22/EN/Datasheet_RFMB-22_42_62.pdf'
    },
    {
        name: 'RFMB-42/',
        type: 'controller',
        tech: 'wireless',
        material: 'metal',
        icons: 4,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-40',
        previewImage: 'metal-40',
        renderImage: 'metal-4',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 142.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFMB-22/EN/Datasheet_RFMB-22_42_62.pdf'
    },
    {
        name: 'RFMB-62/',
        type: 'controller',
        tech: 'wireless',
        material: 'metal',
        icons: 6,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-60',
        previewImage: 'metal-60',
        renderImage: 'metal-6',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'D',
            2: 'G',
            3: 'C',
            4: 'F',
            5: 'I'
        },
        price: 149.5,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFMB-22/EN/Datasheet_RFMB-22_42_62.pdf'
    },

    // Plastic

    {
        name: 'RFWB-20/G',
        type: 'controller',
        tech: 'wireless',
        material: 'plastic',
        icons: 2,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'plastic-20',
        previewImage: 'plastic-1',
        renderImage: 'plastic-1',
        actuator: false,
        buttonCodes: {
            0: 'D',
            1: 'F'
        },
        price: 39.31,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFWB-20_G/share_dokumentace/AKTUAL/EN/Datasheet_RFWB-20G_40G_20GB_40GB.pdf'
    },
    {
        name: 'RFWB-40/G',
        type: 'controller',
        tech: 'wireless',
        material: 'plastic',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'plastic-40',
        previewImage: 'plastic-2',
        renderImage: 'plastic-2',
        actuator: false,
        buttonCodes: {
            0: 'A',
            1: 'G',
            2: 'C',
            3: 'I'
        },
        price: 43.35,
        datasheetUrl: 'https://www.elkoep.com/media/import/Elko/RFx/RFWB-40_G/share_dokumentace/AKTUAL/EN/Datasheet_RFWB-20G,%20RFWB-40G.pdf'
    },
    

    // BUS

    {
        name: "GSB3-40/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 4,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40',
        renderImage: 'glass'
    },
    {
        name: "GSB3-60/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 6,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-60',
        previewImage: 'glass-60',
        renderImage: 'glass'
    },
    {
        name: "GSB3-90/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 9,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-90',
        previewImage: 'glass-90',
        renderImage: 'glass'
    },
    {
        name: "GSB3-240/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 4,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-40',
        previewImage: 'glass-40-round',
        renderImage: 'glass-round'
    },
    {
        name: "GSB3-260/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 6,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-60',
        previewImage: 'glass-60-round',
        renderImage: 'glass-round'
    },
    {
        name: "GSB3-290/S",
        type: 'controller',
        tech: 'bus',
        material: 'glass',
        icons: 9,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-90',
        previewImage: 'glass-90-round',
        renderImage: 'glass-round'
    },

    {
        name: 'MSB3-40/',
        type: 'controller',
        tech: 'bus',
        material: 'metal',
        icons: 4,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-40',
        previewImage: 'metal-40',
        renderImage: 'metal-4'
    },
    {
        name: 'MSB3-60/',
        type: 'controller',
        tech: 'bus',
        material: 'metal',
        icons: 6,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-60',
        previewImage: 'metal-60',
        renderImage: 'metal-6'
    },
    /*{
        name: 'MSB3-90/',
        type: 'controller',
        tech: 'bus',
        material: 'metal',
        icons: 9,
        round: false,
        colors: ['silver', 'brass', 'black', 'copper'],
        colorsShortcut: ['SS', 'GG', 'BB', 'CC'],
        className: 'metal-90',
        previewImage: 'metal-90',
        renderImage: 'metal-9'
    },*/

    {
        name: 'GRT3-70/',
        type: 'thermostat',
        tech: "bus",
        material: 'glass',
        icons: 7,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-7',
        previewImage: 'grt3-7',
        renderImage: 'grt3',
        unremoveableIcons: true,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/1H",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/12H",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11H",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/11I",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/11J",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "green",
                "icon": "controllers/green/12F",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/1G",
                "applianceId": null,
            }
        ]
    },
    {
        name: 'GRT3-270/',
        type: 'thermostat',
        tech: "bus",
        material: 'glass',
        icons: 7,
        round: true,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-7',
        previewImage: 'grt3-7-round',
        renderImage: 'grt3-round',
        unremoveableIcons: true,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/1H",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/12H",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11H",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "%c",
                "icon": "controllers/%c/11I",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "%c",
                "icon": "controllers/%c/11J",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "green",
                "icon": "controllers/green/12F",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/1G",
                "applianceId": null,
            }
        ]
    },
    {
        name: 'GRT3-100/',
        type: 'thermostat',
        tech: "bus",
        material: 'glass',
        icons: 8,
        round: false,
        colors: ['black', 'white'],
        colorsShortcut: ['B', 'W'],
        className: 'glass-thermostat-8',
        iconsScale: 0.5,
        previewImage: 'grt3-8',
        renderImage: 'grt3-100',
        unremoveableIcons: true,
        defaultIconsData: [
            {
                "position": 0,
                "color": "%c",
                "icon": "controllers/%c/2C",
                "applianceId": null,
            },
            {
                "position": 1,
                "color": "%c",
                "icon": "controllers/%c/2D",
                "applianceId": null,
            },
            {
                "position": 2,
                "color": "%c",
                "icon": "controllers/%c/11L",
                "applianceId": null,
            },
            {
                "position": 3,
                "color": "red",
                "icon": "controllers/red/10C",
                "applianceId": null,
            },
            {
                "position": 4,
                "color": "green",
                "icon": "controllers/green/10A",
                "applianceId": null,
            },
            {
                "position": 5,
                "color": "%c",
                "icon": "controllers/%c/1A",
                "applianceId": null,
            },
            {
                "position": 6,
                "color": "%c",
                "icon": "controllers/%c/12C",
                "applianceId": null,
            },
            {
                "position": 7,
                "color": "%c",
                "icon": "controllers/%c/11E",
                "applianceId": null,
            }
        ]
    },
]

export const iconsColor = {
    black: 'white',
    white: 'black',
    silver: 'black',
    brass: 'black',
    copper: 'white'
}